import React from "react";
import useLeagueVocabulary from "../hooks/useLeagueVocabulary";

export default function ClubTimeline({ events = [] }) {
  const vocabulary = useLeagueVocabulary();
  return (
    <section className="league-panel league-profile-section">
      <div className="league-panel-head"><div><p>{vocabulary.singular} history</p><h2>Timeline</h2></div></div>
      <div className="league-club-timeline">
        {events.length ? events.map((event) => (
          <article key={event.id}><i /><div><strong>{event.label}</strong><span>{event.detail}</span></div></article>
        )) : <div className="league-empty">{vocabulary.singular} milestones will appear here.</div>}
      </div>
    </section>
  );
}
